import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { CONTENT } from "../i18n/content";

const BASE = "https://greengatesrl.it";

const ROUTE_META = {
  "/": {
    title: "Green Gate — Interior Design e General Contractor a Roma",
    desc: "Green Gate S.r.l. — Showroom e general contractor di interior design a Roma. Progettazione, cantiere e arredamenti su misura, seguiti chiavi in mano.",
  },
  "/chi-siamo": {
    title: "Chi Siamo — Studio di Interior Design a Roma | Green Gate",
    desc: "Le persone e i laboratori artigiani dietro i progetti: chi progetta, chi tiene il cantiere e chi segue lo showroom si parla ogni giorno.",
  },
  "/metodo": {
    title: "Il Metodo — Cantiere Chiavi in Mano, Roma | Green Gate",
    desc: "Un'unica regia per progettazione, preventivazione, cantiere, forniture e logistica: il percorso Green Gate senza interruzioni, dalla prima idea alla consegna.",
  },
  "/works": {
    title: "Progetti di Interior Design e Contract | Green Gate Roma",
    desc: "Una selezione dei nostri progetti: appartamenti, attici, ville e spazi commerciali seguiti chiavi in mano tra Roma, i Castelli Romani e Parigi.",
  },
  "/showroom": {
    title: "Showroom a Roma, a due passi da Trastevere | Green Gate",
    desc: "Showroom di arredamento e interior design nel centro storico di Roma, a due passi da Trastevere: materiali, finiture e i migliori marchi del design.",
  },
  "/contatti": {
    title: "Contatti — Consulenza Interior Design Roma | Green Gate",
    desc: "Raccontaci il tuo progetto: lo studio Green Gate di Roma segue interior design, cantiere e showroom dalla prima idea alla consegna finale.",
  },
  "/servizi/architettura-interior-design": {
    title: "Architettura e Interior Design — Servizi | Green Gate Roma",
    desc: "Dalla prima idea alla realizzazione finale: progettazione architettonica e d'interni seguita dallo studio Green Gate di Roma, con cura per i dettagli.",
  },
  "/servizi/general-contracting": {
    title: "General Contracting — Ristrutturazioni Roma | Green Gate",
    desc: "Un unico referente a Roma per preventivazione, gestione del cantiere, maestranze, forniture e logistica interna: la ristrutturazione chiavi in mano.",
  },
  "/servizi/showroom": {
    title: "Showroom e Spazi Commerciali — Servizi | Green Gate",
    desc: "Spazi vendita seguiti chiavi in mano: design d'interni, luci scenografiche, materiali e forniture per un'esperienza d'acquisto memorabile.",
  },
  "/servizi/omniway": {
    title: "Omniway — Pratiche e Adempimenti di Cantiere | Green Gate",
    desc: "Ogni intervento ha una via burocratica diversa: CILA, SCIA e permessi presi in carico dall'inizio alla fine dal team Green Gate.",
  },
};

function upsertMeta(attr, key, value) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

function upsertCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function Seo() {
  const { pathname } = useLocation();

  useEffect(() => {
    let meta = ROUTE_META[pathname];
    if (!meta && pathname.startsWith("/progetti/")) {
      const slug = pathname.split("/")[2];
      const project = CONTENT.it.portfolio.items.find((p) => p.slug === slug);
      if (project) {
        meta = {
          title: `${project.title} — Progetto Interior Design | Green Gate`,
          desc: project.desc ? project.desc.slice(0, 158) : ROUTE_META["/"].desc,
        };
      }
    }
    if (!meta) meta = ROUTE_META["/"];

    document.title = meta.title;
    upsertMeta("name", "description", meta.desc);
    upsertMeta("property", "og:title", meta.title);
    upsertMeta("property", "og:description", meta.desc);
    upsertMeta("property", "og:url", BASE + pathname);
    upsertCanonical(BASE + pathname);
  }, [pathname]);

  return null;
}
